module.exports = __webpack_public_path__ + "img/shikan-banner.f862c8e9.png";